<template>
  <TemplatePage
    :title="$tc('bonusList.actions')"
    title-img="/img/promotions/title.svg"
    :seo-title="get_seoPage.title"
    :seo-description="get_seoPage.description"
    twitter-img-url="/img/seo/promotion/promotion_1200_1200.jpg"
    og-img-url="/img/seo/promotion/promotion_1200_630.jpg"
  >
    <div class="promo-page">
      <ClientOnly>
        <SkeletonList v-if="(get_onlineBanners.isLoading || !isMountedMainComponent) && !get_onlineBanners.data.length" />
      </ClientOnly>

      <div v-onmount="() => isMountedMainComponent = true" class="promo-page__list">
        <PromoCard
          v-for="(item, index) in get_onlineBanners.data"
          :key="index"
          :data="item"
          class="promo-page__item"
        />
      </div>
    </div>
  </TemplatePage>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SkeletonList from '~/components/Promotions/Skeletons/SkeletonList'
import TemplatePage from '~/components/Base/TemplatePage'
import { jsonldArticle } from '~/util/helpers/jsonldHelper'

export default {
  name: 'PromotionsPage',
  components: {
    PromoCard: () => import('~/components/shared/Cards/CardPromotionPreview'),
    TemplatePage,
    SkeletonList,
  },
  layout: 'main',
  jsonld() {
    return jsonldArticle(this.$config.cloudUrl, this.get_seoPage, this.$route.path)
  },
  async fetch() {
    try {
      await Promise.allSettled([
        this.fetch_banners('online'),
        this.fetch_seoPage(this.$route.path),
      ])
    }
    catch (e) {
      e({ statusCode: 404 })
    }
  },
  computed: {
    ...mapGetters('seo', ['get_seoPage']),
    ...mapGetters('billboard', [
      'get_onlineBanners',
    ]),
  },
  methods: {
    ...mapActions('billboard', ['fetch_banners']),
    ...mapActions('seo', ['fetch_seoPage']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
